import { MakeLogicType, connect, kea, path, props } from 'kea'
import { forms } from 'kea-forms'
import type { DeepPartial, DeepPartialMap, FieldName, ValidationErrorType } from 'kea-forms'

import api from 'lib/api'
import { integrationsLogic } from 'lib/integrations/integrationsLogic'
import { lemonToast } from 'lib/lemon-ui/LemonToast'

import { IntegrationType } from '~/types'

export interface AzureBlobSetupModalLogicProps {
    isOpen: boolean
    integration?: IntegrationType | null
    onComplete: (integrationId?: number) => void
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface azureBlobSetupModalLogicValues {
    azureBlobIntegration: {
        connectionString: string
    }
    azureBlobIntegrationAllErrors: Record<string, any>
    azureBlobIntegrationChanged: boolean
    azureBlobIntegrationErrors: DeepPartialMap<
        {
            connectionString: string
        },
        ValidationErrorType
    >
    azureBlobIntegrationHasErrors: boolean
    azureBlobIntegrationManualErrors: Record<string, any>
    azureBlobIntegrationTouched: boolean
    azureBlobIntegrationTouches: Record<string, boolean>
    azureBlobIntegrationValidationErrors: DeepPartialMap<
        {
            connectionString: string
        },
        ValidationErrorType
    >
    isAzureBlobIntegrationSubmitting: boolean
    isAzureBlobIntegrationValid: boolean
    showAzureBlobIntegrationErrors: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface azureBlobSetupModalLogicActions {
    loadIntegrations: () => any // integrationsLogic
    resetAzureBlobIntegration: (values?: { connectionString: string }) => {
        values?: {
            connectionString: string
        }
    }
    setAzureBlobIntegrationManualErrors: (errors: Record<string, any>) => {
        errors: Record<string, any>
    }
    setAzureBlobIntegrationValue: (
        key: FieldName,
        value: any
    ) => {
        name: FieldName
        value: any
    }
    setAzureBlobIntegrationValues: (
        values: DeepPartial<{
            connectionString: string
        }>
    ) => {
        values: DeepPartial<{
            connectionString: string
        }>
    }
    submitAzureBlobIntegration: () => {
        value: boolean
    }
    submitAzureBlobIntegrationFailure: (
        error: Error,
        errors: Record<string, any>
    ) => {
        error: Error
        errors: Record<string, any>
    }
    submitAzureBlobIntegrationRequest: (azureBlobIntegration: { connectionString: string }) => {
        azureBlobIntegration: {
            connectionString: string
        }
    }
    submitAzureBlobIntegrationSuccess: (azureBlobIntegration: { connectionString: string }) => {
        azureBlobIntegration: {
            connectionString: string
        }
    }
    touchAzureBlobIntegrationField: (key: string) => {
        key: string
    }
}

export type azureBlobSetupModalLogicType = MakeLogicType<
    azureBlobSetupModalLogicValues,
    azureBlobSetupModalLogicActions,
    AzureBlobSetupModalLogicProps
>

export const azureBlobSetupModalLogic = kea<azureBlobSetupModalLogicType>([
    path(['integrations', 'azure-blob', 'azureBlobSetupModalLogic']),
    props({} as AzureBlobSetupModalLogicProps),
    connect(() => ({
        actions: [integrationsLogic, ['loadIntegrations']],
    })),
    forms(({ props, actions, values }) => ({
        azureBlobIntegration: {
            defaults: {
                connectionString: '',
            },
            errors: ({ connectionString }) => ({
                connectionString: !connectionString.trim()
                    ? 'Connection string is required'
                    : !connectionString.includes('AccountName=')
                      ? 'Connection string must contain AccountName'
                      : undefined,
            }),
            submit: async () => {
                try {
                    const integration = await api.integrations.create({
                        kind: 'azure-blob',
                        config: {
                            connection_string: values.azureBlobIntegration.connectionString,
                        },
                    })
                    actions.loadIntegrations()
                    lemonToast.success('Azure Blob Storage connection created successfully!')
                    props.onComplete(integration.id)
                } catch (error: any) {
                    lemonToast.error(error.detail || 'Failed to create Azure Blob Storage connection')
                    throw error
                }
            },
        },
    })),
])
